import { jsPDF } from "jspdf";

const GOLD = [245, 158, 11];
const INK = [11, 12, 14];
const PANEL = [27, 40, 54];

export function generateDesignPdf({
  len,
  wid,
  cols = 0,
  rows = 0,
  count = 0,
  kw = 0,
  gen = 0,
  save = 0,
  subsidy = 0,
  model,
  tilt = 18,
  pitchFt = 0,
  shadowFt = 0,
  shadowSafe = true,
}) {
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape" });
  const W = 297;
  const H = 210;

  doc.setFillColor(...INK);
  doc.rect(0, 0, W, 26, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(15);
  doc.setTextColor(...GOLD);
  doc.text("MAA SAKUMBRI SOLAR", 14, 10.5);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(235);
  doc.text("maasakumbrisolar.com   |   Call / WhatsApp +91 79832 17276", 14, 17);
  doc.text("Rajpur Chhajpur, Tehsil Budhana, Distt. Muzaffarnagar - 247775", 14, 21.5);
  doc.setTextColor(170);
  doc.text(`Generated ${new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}`, W - 14, 15, { align: "right" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(19);
  doc.setTextColor(35);
  doc.text("Your Solar Roof Design", 14, 40);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(110);
  doc.text(`${tilt}° tilt  ·  ${shadowSafe ? "shadow-free row spacing" : "dense layout"}  ·  winter 9 AM worst-case sun`, 14, 46.5);

  const bx = 14, by = 52, bw = 186, bh = 128;
  doc.setFillColor(247, 245, 240);
  doc.roundedRect(bx, by, bw, bh, 3, 3, "F");

  const s = Math.min((bw - 24) / len, (bh - 26) / wid);
  const rw = len * s;
  const rh = wid * s;
  const rx = bx + (bw - rw) / 2;
  const ry = by + (bh - rh) / 2 + 2;

  const drawTile = (x, y, w, h, textured) => {
    doc.setFillColor(...PANEL);
    doc.setDrawColor(190, 175, 130);
    doc.setLineWidth(0.12);
    doc.roundedRect(x, y, w, h, 0.4, 0.4, "FD");
    if (textured && w > 4 && h > 5) {
      doc.setDrawColor(235, 200, 120);
      doc.setLineWidth(0.06);
      doc.line(x + w / 3, y + 0.4, x + w / 3, y + h - 0.4);
      doc.line(x + (2 * w) / 3, y + 0.4, x + (2 * w) / 3, y + h - 0.4);
      doc.line(x + 0.4, y + h / 2, x + w - 0.4, y + h / 2);
    }
  };

  const drawShadow = (x, y, w, h, label) => {
    doc.setFillColor(252, 226, 226);
    doc.setDrawColor(214, 120, 120);
    doc.setLineWidth(0.2);
    doc.rect(x, y, w, h, "FD");
    if (label && h > 2.5) {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6.5);
      doc.setTextColor(200, 60, 60);
      doc.text(`SHADOW ZONE ${shadowFt.toFixed(1)} ft`, x + w / 2, y + h / 2 + 1, { align: "center" });
    }
  };

  const innerPad = 1.5 * s;
  const ux = rx + innerPad;
  const uy = ry + innerPad;
  const uw = rw - 2 * innerPad;
  const uh = rh - 2 * innerPad;
  const gap = Math.min(1, Math.max(0.35, 0.06 * s));
  const tileW = cols ? (uw - gap * (cols - 1)) / cols : 0;

  if (count > 0 && cols > 0 && rows > 0) {
    if (shadowSafe && rows > 1 && pitchFt > 0) {
      const spanFt = (rows - 1) * pitchFt + model.lenFt * Math.cos((tilt * Math.PI) / 180);
      const pp = uh / spanFt;
      const footprintPx = model.lenFt * Math.cos((tilt * Math.PI) / 180) * pp;
      const pitchPx = pitchFt * pp;
      const shadowPx = shadowFt * pp;
      for (let ri = 0; ri < rows; ri++) {
        const yTop = uy + ri * pitchPx;
        if (count > 2000) {
          doc.setFillColor(...PANEL);
          doc.rect(ux, yTop, uw, footprintPx, "F");
          doc.setDrawColor(235, 200, 120);
          doc.setLineWidth(0.06);
          const step = tileW + gap;
          for (let x = ux + step; x < ux + uw - 0.5; x += step) doc.line(x, yTop, x, yTop + footprintPx);
        } else {
          for (let c = 0; c < cols; c++) drawTile(ux + c * (tileW + gap), yTop, tileW, footprintPx, count <= 150);
        }
        if (ri < rows - 1) drawShadow(ux, yTop + footprintPx, uw, shadowPx, ri === 0);
      }
    } else {
      const tileH = uh / rows;
      for (let ri = 0; ri < rows; ri++) {
        const yTop = uy + ri * tileH;
        if (count > 2000) {
          doc.setFillColor(...PANEL);
          doc.rect(ux, yTop, uw, tileH, "F");
          doc.setDrawColor(235, 200, 120);
          doc.setLineWidth(0.06);
          const step = tileW + gap;
          for (let x = ux + step; x < ux + uw - 0.5; x += step) doc.line(x, yTop, x, yTop + tileH);
        } else {
          for (let c = 0; c < cols; c++) drawTile(ux + c * (tileW + gap), yTop, tileW, tileH, count <= 150);
        }
      }
    }
  } else {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(150);
    doc.text("Roof too small for a panel row - increase the size.", rx + rw / 2, ry + rh / 2, { align: "center" });
  }

  // walkway dashed outline on top
  doc.setDrawColor(180, 170, 140);
  doc.setLineWidth(0.25);
  doc.setLineDashPattern([1.2, 1.2], 0);
  doc.roundedRect(rx + 1.5 * s, ry + 1.5 * s, rw - 3 * s, rh - 3 * s, 1.5, 1.5);
  doc.setLineDashPattern([], 0);

  // sun indicator
  const sunX = rx + rw - 6;
  const sunY = Math.max(ry - 7, by + 6);
  doc.setFillColor(...GOLD);
  doc.circle(sunX, sunY, 2.4, "F");
  doc.setDrawColor(...GOLD);
  doc.setLineWidth(0.45);
  for (let a = 0; a < 8; a++) {
    const ang = (a * Math.PI) / 4;
    doc.line(sunX + Math.cos(ang) * 3.4, sunY + Math.sin(ang) * 3.4, sunX + Math.cos(ang) * 4.8, sunY + Math.sin(ang) * 4.8);
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(140);
  doc.text("WINTER 9 AM SUN", sunX - 8, sunY + 1.2, { align: "right" });

  // dimensions
  const dimColor = [120, 120, 120];
  doc.setDrawColor(...dimColor);
  doc.setLineWidth(0.3);
  const dOff = 4.5;
  doc.line(rx, ry + rh + dOff, rx + rw, ry + rh + dOff);
  doc.line(rx, ry + rh + dOff - 1.4, rx, ry + rh + dOff + 1.4);
  doc.line(rx + rw, ry + rh + dOff - 1.4, rx + rw, ry + rh + dOff + 1.4);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(70);
  doc.text(`${len} ft`, rx + rw / 2, ry + rh + dOff + 4, { align: "center" });
  doc.line(rx - dOff, ry, rx - dOff, ry + rh);
  doc.line(rx - dOff - 1.4, ry, rx - dOff + 1.4, ry);
  doc.line(rx - dOff - 1.4, ry + rh, rx - dOff + 1.4, ry + rh);
  doc.text(`${wid} ft`, rx - dOff - 2.5, ry + rh / 2, { angle: 90, align: "center" });

  // summary column
  const sx = 210;
  const sw = 73;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12.5);
  doc.setTextColor(35);
  doc.text("Design summary", sx, 56);
  const data = [
    ["Panel model", model.name],
    ["Roof size", `${len} x ${wid} ft`],
    ["Panels", String(count)],
    ["System size", kw >= 1000 ? `${(kw / 1000).toFixed(2)} MW` : `${kw.toFixed(1)} kW`],
    ["Monthly generation", `${Math.round(gen).toLocaleString("en-IN")} units`],
    ["Monthly savings", `Rs. ${Math.round(save).toLocaleString("en-IN")}`],
    ["25-year savings", `Rs. ${Math.round(save * 25).toLocaleString("en-IN")}`],
    ["Govt subsidy", `Rs. ${Math.round(subsidy).toLocaleString("en-IN")}`],
    ["Tilt / shadow", `${tilt} deg - pitch ${pitchFt.toFixed(1)} ft`],
  ];
  let y = 65;
  data.forEach(([label, value]) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(130);
    doc.text(label, sx, y);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9.5);
    doc.setTextColor(25);
    doc.text(value, sx, y + 5, { maxWidth: sw });
    y += 11.5;
  });

  // legend
  y += 2;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(60);
  doc.text("Legend", sx, y);
  y += 5;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  drawTile(sx, y, 6, 3.2, false);
  doc.setTextColor(80);
  doc.text("Panel area", sx + 9, y + 2.6);
  y += 6;
  drawShadow(sx, y, 6, 3.2, false);
  doc.setTextColor(80);
  doc.text("Shadow zone (winter 9 AM)", sx + 9, y + 2.6);
  y += 6;
  doc.setDrawColor(180, 170, 140);
  doc.setLineWidth(0.25);
  doc.setLineDashPattern([1, 1], 0);
  doc.roundedRect(sx, y, 6, 3.2, 0.8, 0.8);
  doc.setLineDashPattern([], 0);
  doc.setTextColor(80);
  doc.text("Walkway margin", sx + 9, y + 2.6);

  // footer
  doc.setFillColor(...INK);
  doc.rect(0, H - 15, W, 15, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9.5);
  doc.setTextColor(...GOLD);
  doc.text("Get your free quote:  maasakumbrisolar.com  |  Call / WhatsApp +91 79832 17276", 14, H - 6);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(160);
  doc.text("Estimates only - final design confirmed after free site survey.", W - 14, H - 6, { align: "right" });

  doc.save(`MSS-solar-design-${len}x${wid}ft.pdf`);
}

export default generateDesignPdf;
